import UserSettings from "../types/UserSettings";
import { nanoid } from "@reduxjs/toolkit";

export interface UserState {
    usersettings?: UserSettings;
    isDirty: boolean;
    isSaving: boolean;
    sessionId?: string;
    showJobRunsDialog: boolean;
}

export const initialState: UserState = {
    isDirty: false,
    isSaving: false,
    sessionId: nanoid(),
    showJobRunsDialog: false,
};
